module.exports = __webpack_public_path__ + "image-3edb3491d76c.png";